import React, { useContext } from "react";
import PropTypes from "prop-types";
import { DomestikaLiveTag } from "@domestika-dev/prudencio/dist/atoms/DomestikaLiveTag";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { LiveSessionContext } from "../../../context/LiveSessionContext";
import * as LiveSessionStates from "../../../constants/liveSessionStates";
import { ChatHeaderTimer } from "./ChatHeaderTimer";
import { ChatHeaderViewers } from "./ChatHeaderViewers";

export const ChatHeader = ({ chatHeaderRef }) => {
  const { liveSession } = useContext(LiveSessionContext);

  const isLiveSessionStreaming = () => liveSession?.aasmState === LiveSessionStates.STREAMING;

  return (
    <Flex
      ref={chatHeaderRef}
      padding={[4, 4, 4]}
      height="70px"
      borderBottom="1px solid"
      borderTop="1px solid"
      borderColor="durian"
      alignItems="center"
      flexGrow={0}
      flexShrink={0}
    >
      {isLiveSessionStreaming() && <DomestikaLiveTag />}
      <Flex
        justifyContent="flex-end"
        alignItems="center"
        color="guijarro"
        flexGrow={1}
        style={{ whiteSpace: "pre-wrap" }}
      >
        {isLiveSessionStreaming() && <ChatHeaderTimer />}
        <ChatHeaderViewers />
      </Flex>
    </Flex>
  );
};

ChatHeader.propTypes = {
  chatHeaderRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType }),
  ]),
};

ChatHeader.defaultProps = {
  chatHeaderRef: null,
};

export default ChatHeader;
